import React from "react";
import { FaAngleRight } from "react-icons/fa";
import "./About.css";

const About = () => {
  // Define skills for three columns
  const col1Skills = ["JavaScript", "Java", "C", "Bootstrap"];
  const col2Skills = ["MongoDB", "ExpressJS", "ReactJS", "NodeJS"];
  const col3Skills = ["Git", "Github", "MySQL", "CSS"];

  return (
    <section className="about-section" id="about">
      <h2 className="about-heading">About</h2>
      <div className="about-container">
        {/* Left: Text Section */}
        <div className="about-text">
          <p className="greeting">Hello! My name is Vikas.</p>
          <p className="about-description">
            I am a motivated student pursuing Electronic and Computer
            Engineering. Passionate about developing innovative and efficient
            solutions, I continuously seek opportunities to learn and grow in my
            field. Skilled in multiple programming languages and frameworks, I
            strive to deliver exceptional results.
          </p>
          {/* Skills arranged in three columns */}
          <div className="skill-list">
            <div className="skill-column">
              <ul className="skill-bullets">
                {col1Skills.map((skill, idx) => (
                  <li key={idx}>
                    <FaAngleRight className="bullet-icon" />
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
            <div className="skill-column">
              <ul className="skill-bullets">
                {col2Skills.map((skill, idx) => (
                  <li key={idx}>
                    <FaAngleRight className="bullet-icon" />
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
            <div className="skill-column">
              <ul className="skill-bullets">
                {col3Skills.map((skill, idx) => (
                  <li key={idx}>
                    <FaAngleRight className="bullet-icon" />
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Right: Image Section */}
        <div className="about-image">
          <div className="profile-img">
            <img
              src={process.env.PUBLIC_URL + "/profile.jpg"}
              alt="Vikas Pawar"
              className="inner-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
